"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesAudioTypeGroupSchema = void 0;
exports.ServicesAudioTypeGroupSchema = {
    "$id": "https://www.redbull.com/schemas/type-groups/services/audio.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ServicesAudioTypeGroup",
    "description": "ServicesAudioTypeGroup represents one of the following types: AcastPodcast, MegaphonePodcastEpisode, MixcloudAudio, RBMNAudio, SoundcloudAudio, SoundcloudAudio, SoundcloudSocialLink, Spotify, Spotify, SpreakerAudio",
    "oneOf": [
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/acast-audio/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/megaphone-podcast-episode/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/mixcloud-audio/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/rbmn-audio/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/soundcloud-audio/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/soundcloud-audio/2.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/soundcloud-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/spotify-audio/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/spotify-audio/2.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/spreaker-audio/1.schema.json"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXVkaW8uc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL21vZHVsZXMvdHlwZS1ncm91cHMvc2VydmljZXMvYXVkaW8uc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsNEJBQTRCLEdBQUc7SUFDMUMsS0FBSyxFQUFFLHdFQUF3RTtJQUMvRSxTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSx3QkFBd0I7SUFDakMsYUFBYSxFQUFFLHdOQUF3TjtJQUN2TyxPQUFPLEVBQUU7UUFDUDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxnRkFBZ0Y7U0FDekY7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSw4RkFBOEY7U0FDdkc7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxtRkFBbUY7U0FDNUY7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSwrRUFBK0U7U0FDeEY7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxxRkFBcUY7U0FDOUY7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxxRkFBcUY7U0FDOUY7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSwwRkFBMEY7U0FDbkc7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxrRkFBa0Y7U0FDM0Y7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxrRkFBa0Y7U0FDM0Y7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxtRkFBbUY7U0FDNUY7S0FDRjtDQUNGLENBQUEifQ==